// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PremiumPage__root--Cacu {

}

.PremiumPage__contentHeader--O6_N {
    width: 100%;
    background-color: var(--obscure-color);
    padding: 4px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 24px;
}

@media screen and (min-width: 1024px) {

.PremiumPage__contentHeader--O6_N {
        margin-bottom: 32px
}
    }

.PremiumPage__title--hXRd {
    background-color: var(--tertiary-color);
    padding: 20px;
    font-weight: 700;
    font-size: 26px;
    line-height: 34px;
    color: var(--darkest-color);
    border-radius: 12px;
}

.PremiumPage__bgImage--WK9g {
    width: 100%;
    height: 108px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: var(--mobile-bg-image-url);
    border-radius: 12px;
    overflow: hidden;
}

@media screen and (min-width: 1024px) {

.PremiumPage__bgImage--WK9g {
        background-image: var(--desktop-bg-image-url)
}
    }

.PremiumPage__loaderWrapper--Vx7W {
    display: flex;
    align-items: center;
    justify-content: center;
}

.PremiumPage__secondaryTitle--AU55 {
    font-size: 26px;
    font-weight: 700;
    line-height: 34px;
    color: var(--secondary-color);
    text-align: center;
    margin: 0 auto;
    margin-bottom: 24px;
    max-width: 410px;
}

.PremiumPage__blockWithIndent--VIk7 {
    margin: 0 auto;
    max-width: 600px;
    margin-bottom: 32px;
}

.PremiumPage__guaranteeBlock--IUfA {
    margin: 0 auto;
    max-width: 600px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/pages/PremiumPage/PremiumPage.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AAKvB;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,uCAAuC;IACvC,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;AAKpB;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".root {\n\n}\n\n.contentHeader {\n    width: 100%;\n    background-color: var(--obscure-color);\n    padding: 4px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 24px;\n\n    @media (--large) {\n        margin-bottom: 32px;\n    }\n}\n\n.title {\n    background-color: var(--tertiary-color);\n    padding: 20px;\n    font-weight: 700;\n    font-size: 26px;\n    line-height: 34px;\n    color: var(--darkest-color);\n    border-radius: 12px;\n}\n\n.bgImage {\n    width: 100%;\n    height: 108px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    background-image: var(--mobile-bg-image-url);\n    border-radius: 12px;\n    overflow: hidden;\n\n    @media (--large) {\n        background-image: var(--desktop-bg-image-url);\n    }\n}\n\n.loaderWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.secondaryTitle {\n    font-size: 26px;\n    font-weight: 700;\n    line-height: 34px;\n    color: var(--secondary-color);\n    text-align: center;\n    margin: 0 auto;\n    margin-bottom: 24px;\n    max-width: 410px;\n}\n\n.blockWithIndent {\n    margin: 0 auto;\n    max-width: 600px;\n    margin-bottom: 32px;\n}\n\n.guaranteeBlock {\n    margin: 0 auto;\n    max-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PremiumPage__root--Cacu`,
	"contentHeader": `PremiumPage__contentHeader--O6_N`,
	"title": `PremiumPage__title--hXRd`,
	"bgImage": `PremiumPage__bgImage--WK9g`,
	"loaderWrapper": `PremiumPage__loaderWrapper--Vx7W`,
	"secondaryTitle": `PremiumPage__secondaryTitle--AU55`,
	"blockWithIndent": `PremiumPage__blockWithIndent--VIk7`,
	"guaranteeBlock": `PremiumPage__guaranteeBlock--IUfA`
};
export default ___CSS_LOADER_EXPORT___;
